module.exports = __webpack_public_path__ + "images/copy694dc0a3be7c8bf09fde759204e383a0.svg";